import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
    
})
export default class TabHead extends Vue {
    @Prop({type:String, default:""}) title!:string
    @Prop({type:Object, default:null}) options!:any
    @Prop({type:Boolean, default:false}) preview!:boolean

    activeIdx:number = 0

    tabClicked(i:any,idx:number){
        if(this.preview) return
        this.activeIdx = idx
        this.$emit('tabChange',i)
    }
}